import invite from '../../../../assets/src/images/invite.png';
import { Image } from 'expo-image';
import { Box, VStack, HStack, Text } from 'native-base';
import { PrimaryButton, PointsTag } from '../../';
import { openModal, useAppDispatch } from '@breakroom-nx/redux';

export const UserReferral = () => {
  const dispatch = useAppDispatch();

  return (
    <Box
      width={'full'}
      bg={'rgba(255, 213, 69, 0.40)'}
      px={'1.25rem'}
      py={'1.25rem'}
      rounded={10}
    >
      <VStack space={4} textAlign={'center'} alignItems={'center'}>
        <Image
          source={{ uri: invite }}
          cachePolicy={'memory-disk'}
          accessibilityLabel={`Enable 2FA Image`}
          style={{
            width: '90%',
            aspectRatio: 1,
          }}
        />
        <VStack space={1} textAlign={'center'} alignItems={'center'}>
          <Text
            fontFamily={'heading'}
            fontSize={23}
            color={'yellow.300'}
            fontWeight={600}
            mb={'3px'}
          >
            The More the Merrier
          </Text>
          <Text
            fontFamily={'heading'}
            fontSize={16}
            color={'yellow.500'}
            fontWeight={600}
            mb={'3px'}
          >
            Get gems when you refer your friends!
          </Text>
        </VStack>
        <VStack space={3} alignItems={'center'}>
          <PrimaryButton
            onPress={() =>
              dispatch(openModal({ modalType: 'InviteFriendToApp' }))
            }
            text={'Invite'}
            bg={'yellow.300'}
            color={'surface.100'}
          />
          <HStack alignItems={'start'} textAlign={'start'} space={2}>
            <HStack alignItems={'center'} rounded={'full'} space={'1px'}>
              <PointsTag amount={200} payment={true} fontSize={12} />
            </HStack>
            <Text color={'#b48900'} fontSize={14}>
              When they create a anonymous account
            </Text>
          </HStack>
          <HStack alignItems={'start'} textAlign={'start'} space={2}>
            <HStack alignItems={'center'} rounded={'full'} space={'1px'}>
              <PointsTag amount={1000} payment={true} fontSize={12} />
            </HStack>
            <Text color={'#b48900'} fontSize={14}>
              When they register for a full account
            </Text>
          </HStack>
        </VStack>
      </VStack>
    </Box>
  );
};
